import { DaoService } from "./DaoService";

export class DepenseService extends DaoService {

    static CLASS_NAME = "App\\Models\\Depense";
    
    static getInstance() {
        return super.getInstance('depense');
    }

    search(data) {
        return DepenseService.post(`${this.prefix}/search`, data);
    }

}